import script from "./ElementFlip.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementFlip.vue?vue&type=script&lang=ts&setup=true"

import "./ElementFlip.vue?vue&type=style&index=0&id=59a1646e&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a1646e"]])

export default __exports__